<template>
    <basic-card>
        <template slot="header">
            {{ $t('administration.operationDefinitionGroups') }}
        </template>
        <data-table
                :configuration="operationDefinitionGroupTableConfig"
                :data="operationDefinitionGroups"
                component-id="operationDefinitionGroupsTable"
                @add="handleAdd"
                @focusedChanged="handleFocusedChanged"
                @delete="handleDelete"
        >
            <template v-if="focusedGroup != null">
                <basic-card>
                    <template slot="header">
                        {{ $t('administration.operationDefinitionGroups') }}
                    </template>
                    <form-wrapper :form-title="`${$t('administration.operationDefinitionGroups')}`">
                        <form-text-input v-model="focusedGroup.systemName" :caption="`${$t('systemName')}`"/>
                        <form-text-input v-model="focusedGroup.displayName" :caption="`${$t('displayName')}`"/>
                        <form-text-input v-model="focusedGroup.description" :caption="`${$t('description')}`"/>
                        <form-multi-select-input :options="operationDefinitionsSelection"
                                                 :caption="`${$t('administration.operations')}`"
                                                 v-model="focusedGroup.operationDefinitions"/>
                    </form-wrapper>


                    <simple-button @press="handleSave">
                        <icon :icon="['fal', 'save']"/>&nbsp;{{ $t('save') }}
                    </simple-button>
                </basic-card>
            </template>
        </data-table>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import DataTable from "../components/table/DataTable";
    import FormWrapper from "../components/form/FormWrapper";
    import SimpleButton from "../components/button/SimpleButton";
    import FormTextInput from "../components/form/FormTextInput";
    import {mapGetters} from "vuex";
    import FormCheckboxInput from "../components/form/FormCheckboxInput";
    import FormMultiSelectInput from "../components/form/FormMultiSelectInput";

    export default {
        name: "OperationDefinitionGroupsView",
        components: {
            FormMultiSelectInput,
            FormCheckboxInput, FormTextInput, SimpleButton, FormWrapper, DataTable, BasicCard
        },

        data: function () {
            return {
                focusedGroup: null,
                operationDefinitionGroupTableConfig: {
                    allowEdit: true,
                    enableAdd: true,
                    enableDelete: true,
                    columns: [
                        {
                            caption: "Id",
                            datum: d => d.id
                        },
                        {
                            caption: this.$t('systemName'),
                            datum: d => d.systemName
                        },
                        {
                            caption: this.$t('displayName'),
                            datum: d => d.displayName
                        }
                    ],
                    actions: [
                        {
                            name: "delete",
                            icon: "trash",
                            tooltip: this.$t('operationDefinition.delete')
                        }
                    ]
                }
            }
        },
        methods: {
            handleFocusedChanged(focused) {
                this.focusedGroup = this.$_.cloneDeep(focused);
            },
            handleAdd() {
                this.focusedGroup = {
                    operationDefinitions: []
                };
            },
            handleSave() {
                this.$store.dispatch("operationDefinitionGroups/saveOperationDefinitionGroup", this.focusedGroup)
                    .then(res => {
                        this.$notify({
                            group: 'application',
                            title: this.$t('operationDefinition.saveSuccessTitle'),
                            text: this.$t('operationDefinition.saveSuccess'),
                            type: "ok"
                        })
                        this.focusedGroup = null;
                    });


            },
            handleDelete(id) {
                this.$store.dispatch("operationDefinitionGroups/deleteOperationDefinitionGroup", id)
                    .then(res => {
                        this.$notify({
                            group: 'application',
                            title: this.$t('operationDefinition.deleteSuccessTitle'),
                            text: this.$t('operationDefinition.deleteSuccess'),
                            type: "ok"
                        })
                    });
            }
        },
        computed: {
            ...mapGetters({
                "operationDefinitions": "operationDefinitions/operationDefinitions",
                "operationDefinitionGroups": "operationDefinitionGroups/operationDefinitionGroups"
            }),
            operationDefinitionsSelection() {
                return [...this.operationDefinitions]
            }
        }

    }
</script>

<style scoped>

</style>